import { Icon } from '@iconify/react';
import boxIcon from '@iconify/icons-ant-design/inbox-outlined';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';

// utils
import PropTypes from 'prop-types';
// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(2, 0),
  color: theme.palette.secondary.darker,
  backgroundColor: theme.palette.secondary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  color: theme.palette.secondary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.secondary.dark, 0)} 0%, ${alpha(
    theme.palette.secondary.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

KitLoadedCard.propTypes = {
  kit: PropTypes.object
};

export default function KitLoadedCard({ kit }) {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={boxIcon} width={35} height={35} />
      </IconWrapperStyle>
      <Typography variant="overline" sx={{ opacity: 0.5 }}>
        {kit.type}
      </Typography>
      <Typography variant="h3">{kit.id}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Software Kit
      </Typography>
    </RootStyle>
  );
}
